<form
  action=""
  class="grip w-full max-w-full pb-5"
  data-testid="custom-field-edit-form"
  [formGroup]="form"
  (submit)="submit()">
  <div class="flex flex-col">
    <!-- Category and custom type fields commented out -->

    @if (
      (this.form.value['si_filter_access'] === 'No' && this.form.value['custom_type'] === 'text') ||
      this.form.value['custom_type'] === 'input_number'
    ) {
      <div class="flex flex-col gap-2 mb-4 mt-4" data-testid="custom-field-edit-form__suffix">
        <label for="suffix">
          {{ 'Suffix' | translate }}
        </label>
        <input
          formControlName="suffix"
          id="suffix"
          type="text"
          pInputText
          class="w-full"
          data-testid="custom-field-edit-form__suffix-input" />
        <small class="block mt-1 line-height-3 text-xs">
          {{
            'You can specify a suffix or even select Si units to appear after the field.'
              | translate
          }}</small
        >
      </div>
    }

    @if (
      this.form.value['custom_type'] === 'input_number' ||
      this.form.value['custom_type'] === 'range'
    ) {
      <div class="flex flex-col gap-2 mb-4" data-testid="custom-field-edit-form__si-filter">
        <label for="si_filter_access" class="font-bold">
          {{
            this.form.value['custom_type'] === 'range'
              ? ('Integrated international system of units unit and currency filter' | translate)
              : ('International system of units filter' | translate)
          }}
        </label>
        <p-select
          optionValue="code"
          optionLabel="name"
          data-testid="custom-field-edit-form__si-filter-select"
          [formControlName]="'si_filter_access'"
          [styleClass]="'w-full'"
          [options]="
            this.form.value['custom_type'] === 'range'
              ? si_filter_access_options_range
              : si_filter_access_options
          "
          [showClear]="false"
          (onChange)="resetSiUnitName()" />
        <small class="block leading-6 text-xs">
          {{
            'You can optionally choose a suffix from the International System of Units.' | translate
          }}
        </small>
      </div>
    }

    @if (
      this.form.value['custom_type'] === 'range' &&
      this.form.value['si_filter_access'] === 'Currency'
    ) {
      <div class="flex flex-col gap-2 mb-4" data-testid="custom-field-edit-form__currency">
        <label class="font-bold"> {{ 'Currency' | translate }}</label>
        <offconon-all-currency-dropdown-list
          data-testid="custom-field-edit-form__currency-dropdown"
          [selected_iso_code]="system_data?.currency"
          (selectedCurrencyEvent)="setCurrency($event)" />
        <small class="block leading-6 text-xs">{{
          'Select the currency used for the range value.' | translate
        }}</small>
      </div>
    }
    @if (
      this.form.value['si_filter_access'] === 'Yes' &&
      (this.form.value['custom_type'] === 'input_number' ||
        this.form.value['custom_type'] === 'range')
    ) {
      <div class="flex flex-col gap-2 mb-4" data-testid="custom-field-edit-form__unit-type">
        <label for="si_unit_type_filter" class="font-bold">{{ 'Unit type' | translate }}</label>
        <p-select
          optionValue="code"
          optionLabel="name"
          data-testid="custom-field-edit-form__unit-type-select"
          [formControlName]="'si_unit_type_filter'"
          [styleClass]="'w-full'"
          [options]="si_unit_type_filter_options"
          [showClear]="false"
          (onChange)="onChange($event)" />
      </div>

      <div class="flex flex-col gap-2 mb-4" data-testid="custom-field-edit-form__unit-name">
        <label class="font-bold">{{ 'Unit name' | translate }}</label>
        <offconon-si-units-virtual-scroll-dropdown-common
          data-testid="custom-field-edit-form__unit-name-dropdown"
          [siUnitFormControl]="form.get('si_unit_id')"
          [unit_type]="this.form.value['si_unit_type_filter']"
          (selectedSiUnitEvent)="setSiUnit($event)" />
        <small class="block leading-6 text-xs">
          {{ 'Select the name of the unit that will appear as a suffix.' | translate }}
        </small>
      </div>
    }

    @if (
      this.form.value['custom_type'] !== 'text' &&
      this.form.value['custom_type'] !== 'input_number' &&
      this.form.value['custom_type'] !== 'range'
    ) {
      <div
        class="field mb-4 mt-5 border-top-1 surface-border w-full"
        data-testid="custom-field-edit-form__values-header">
        <div class="text-xl font-bold mb-2 mt-5 text-center">
          {{ 'Custom field values' | translate }}
        </div>
        <div class="text-sm font-light leading-6 text-center">
          {{ 'These values appear as options in the selected custom field options.' | translate }}
        </div>
      </div>
    }

    @if (this.form.value['custom_type'] === 'range') {
      <div
        class="field mb-4 mt-5 border-top-1 surface-border w-full"
        data-testid="custom-field-edit-form__range-header">
        <div class="text-xl font-bold mb-2 mt-5 text-center">
          {{ 'Custom field value range' | translate }}
        </div>
        <div class="text-sm font-light leading-6 text-center">
          {{
            'These value range appear as options in the selected custom field options.' | translate
          }}
        </div>
      </div>
    }
  </div>

  @if (
    this.form.value['custom_type'] !== 'text' &&
    this.form.value['custom_type'] !== 'input_number' &&
    this.form.value['custom_type'] !== 'range'
  ) {
    <offconon-add-custom-filed-value-row-form
      data-testid="custom-field-edit-form__value-rows"
      [form]="form" />
    <div class="pt-3">
      <p-divider class="w-full" />
    </div>
  }

  @if (this.form.value['custom_type'] === 'range') {
    <offconon-range-row-custom-filed-form
      data-testid="custom-field-edit-form__range-rows"
      [si_unit_name]="si_unit_name" />

    <div class="pt-3">
      <p-divider class="w-full" />
    </div>
  }

  <div class="flex flex-row-reverse flex-wrap" data-testid="custom-field-edit-form__actions">
    <div class="flex items-center justify-center">
      <p-button
        icon="pi pi-save"
        iconPos="left"
        type="submit"
        data-testid="custom-field-edit-form__save-button"
        [styleClass]="'w-full'"
        label="{{ 'Save' | translate }}"
        [loading]="loading"
        [disabled]="form.invalid"
        [rounded]="true" />
    </div>
  </div>
</form>
